import React from 'react'
import {
  Switch,
  Route,
  BrowserRouter
} from 'react-router-dom'
import Appointment from './Components/Appointment/Appointment'

/**
 * Main app
 * @returns {void} .
 */
const App = () => (
  <BrowserRouter>
    <Switch>
      <Route
        path="/:publicKey/:onsite"
        component={() => (
          <Appointment />
        )}
      />
      <Route
        path="/:publicKey"
        component={() => (
          <Appointment />
        )}
      />
    </Switch>
  </BrowserRouter>
)

export default App
